import axios from "../service/axios/axios";

export default {
  //系统用户列表
  adminList(data) {
    return axios({
      method: "post",
      url: "platform/admin/adminList",
      data: data,
    });
  },
  //新增系统用户
  addAdmin(adminData) {
    return axios({
      method: "post",
      url: "platform/admin/addAdmin",
      data: adminData,
    });
  },
  //编辑系统用户
  editAdmin(editData) {
    return axios({
      method: "post",
      url: "platform/admin/editAdmin",
      data: editData,
    });
  },
  //锁定或者解锁系统用户
  editAdminStatus({ admin_id, status }) {
    return axios({
      method: "post",
      url: "platform/admin/editAdminStatus",
      data: {
        admin_id,
        status,
      },
    });
  },
  //重置系统用户密码
  editAdminPassword({ admin_id }) {
    return axios({
      method: "post",
      url: "platform/admin/editAdminPassword",
      data: {
        admin_id,
      },
    });
  },
  //删除系统用户
  delAdmin({ admin_id }) {
    return axios({
      method: "post",
      url: "platform/admin/delAdmin",
      data: {
        admin_id,
      },
    });
  },
  //角色列表(用于编辑用户)
  getAdminGroupByList() {
    return axios({
      method: "post",
      url: "platform/admin/getAdminGroupByList",
    });
  },

  //角色列表
  getAdminGroupList({ page, pageNumber }) {
    return axios({
      method: "post",
      url: "platform/admin/getAdminGroupList",
      data: {
        page,
        pageNumber,
      },
    });
  },
  //角色关联系统用户
  adminRoleList({ group_id }) {
    return axios({
      method: "post",
      url: "platform/admin/adminList",
      data: {
        group_id,
        page: 1,
        pageNumber: 100,
      },
    });
  },
  //删除角色
  delAdminGroup({ group_id }) {
    return axios({
      method: "post",
      url: "platform/admin/delAdminGroup",
      data: { group_id },
    });
  },
  //获取权限列表
  ModuleList() {
    return axios({
      method: "post",
      url: "platform/admin/getModuleList",
    });
  },
  //新增角色
  addAdminGroup(data) {
    return axios({
      method: "post",
      url: "platform/admin/addAdminGroup",
      data,
    });
  },
  //编辑角色
  editAdminGroup(data) {
    return axios({
      method: "post",
      url: "platform/admin/editAdminGroup",
      data,
    });
  },
  //设置权限
  setModule({ group_id, module_id_array }) {
    return axios({
      method: "post",
      url: "platform/admin/setModule",
      data: {
        group_id,
        module_id_array,
      },
    });
  },
  //删除系统用户
  delAdmin({ admin_id }) {
    return axios({
      method: "post",
      url: "platform/admin/delAdmin",
      data: {
        admin_id,
      },
    });
  },
  /* **** 分账设置 **** */
  // 获取银联配置账号列表
  getChinaumsHospital(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getChinaumsHospital",
      data,
    });
  },
  // 获取药房剂型银联设置
  getChinaumsHospitalDrugType(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getChinaumsHospitalDrugType",
      data,
    });
  },
  // 设置药房剂型分账
  setChinaumsHospitalDrugType(data) {
    return axios({
      method: "post",
      url: "platform/hospital/setChinaumsHospitalDrugType",
      data,
    });
  },
  // 获取问诊费分账设置
  getChinaumsConsultingGold(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getChinaumsConsultingGold",
      data,
    });
  },
  // 设置问诊费分账
  setChinaumsConsultingGold(data) {
    return axios({
      method: "post",
      url: "platform/hospital/setChinaumsConsultingGold",
      data,
    });
  },
  // 获取体检订单分账设置
  getChinaumsPhysical(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getChinaumsPhysical",
      data,
    });
  },
  // 设置体检订单分账
  setChinaumsPhysical(data) {
    return axios({
      method: "post",
      url: "platform/hospital/setChinaumsPhysical",
      data,
    });
  },
  // 获取会员订单分账设置
  getChinaumsMember(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getChinaumsMember",
      data,
    });
  },
  // 设置会员订单分账
  setChinaumsMember(data) {
    return axios({
      method: "post",
      url: "platform/hospital/setChinaumsMember",
      data,
    });
  },
  // 获取商城订单设置
  getChinaumsShop(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getChinaumsShop",
      data,
    });
  },
  // 设置订单商城订单分账
  setChinaumsShop(data) {
    return axios({
      method: "post",
      url: "platform/hospital/setChinaumsShop",
      data,
    });
  },
  /* **** 剂型提成比例 **** */
  // 获取药房剂型提成比列
  getHospitalDrugTypeProportion(data) {
    return axios({
      method: "post",
      url: "platform/hospital/getHospitalDrugTypeProportion",
      data,
    });
  },
  // 设置药房剂型提成比列
  setHospitalDrugTypeProportion(data) {
    return axios({
      method: "post",
      url: "platform/hospital/setHospitalDrugTypeProportion",
      data,
    });
  },
  /* **** 数据字典 **** */
  // 获取数据字典
  dicList(data) {
    return axios({
      method: "post",
      url: "platform/admin/dicList",
      data,
    });
  },
  // 新增字典数据
  addDic(data) {
    return axios({
      method: "post",
      url: "platform/admin/addDic",
      data,
    });
  },
  // 修改字典数据
  updateDic(data) {
    return axios({
      method: "post",
      url: "platform/admin/updateDic",
      data,
    });
  },
  // 字典数据详情（回显）
  getDicInfo(data) {
    return axios({
      method: "post",
      url: "platform/admin/getDicInfo",
      data,
    });
  },
  /* **** 诊疗首页设置 **** */
  // 获取默认推荐医生来源（回显）
  getLabelCheck(data) {
    return axios({
      method: "post",
      url: "platform/admin/getLabelCheck",
      data,
    });
  },
  // 常见病症/科室设置（回显）
  getCommonDiseasesDepSetting(data) {
    return axios({
      method: "post",
      url: "platform/admin/getCommonDiseasesDepSetting",
      data,
    });
  },
  // 名中医设置（回显）
  getFamousDoctorSetting(data) {
    return axios({
      method: "post",
      url: "platform/admin/getFamousDoctorSetting",
      data,
    });
  },
  // 推荐科室（回显）
  getRecommendDepart(data) {
    return axios({
      method: "post",
      url: "platform/admin/getRecommendDepart",
      data,
    });
  },
  // 推荐医生（回显）
  getDepartDoctor(data) {
    return axios({
      method: "post",
      url: "platform/admin/getDepartDoctor",
      data,
    });
  },
  // 根据标签获取医生列表
  getLabelDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/Doctor/getLabelDoctorList",
      data,
    });
  },
  // 修改医生来源（默认推荐）
  editLabelCheck(data) {
    return axios({
      method: "post",
      url: "platform/admin/editLabelCheck",
      data,
    });
  },
  // 修改医生来源（科室推荐）
  editHomeSettingDep(data) {
    return axios({
      method: "post",
      url: "platform/admin/editHomeSettingDep",
      data,
    });
  },
  // 获取全部科室
  getAllDepart(data) {
    return axios({
      method: "post",
      url: "platform/admin/getAllDepart",
      data,
    });
  },
  // 获取全部医生
  getAllDoctor(data) {
    return axios({
      method: "post",
      url: "platform/admin/getAllDoctor",
      data,
    });
  },
  // 保存常见病症/科室设置
  saveCommonDiseasesDepSetting(data) {
    return axios({
      method: "post",
      url: "platform/admin/saveCommonDiseasesDepSetting",
      data,
    });
  },
  // 修改科室
  updateDepart(data) {
    return axios({
      method: "post",
      url: "platform/admin/updateDepart",
      data,
    });
  },
  // 保存名医堂
  saveFamousDoctorSetting(data) {
    return axios({
      method: "post",
      url: "platform/admin/saveFamousDoctorSetting",
      data,
    });
  },
  // 获取全部名医堂
  getAllFamous(data) {
    return axios({
      method: "post",
      url: "platform/admin/getAllFamous",
      data,
    });
  },
  // 保存默认推荐医生
  saveDepartDoctor(data) {
    return axios({
      method: "post",
      url: "platform/admin/saveDepartDoctor",
      data,
    });
  },
  // 推荐医生设置排序
  setDepartDoctorSort(data) {
    return axios({
      method: "post",
      url: "platform/admin/setDepartDoctorSort",
      data,
    });
  },
  // 保存科室
  saveDepart(data) {
    return axios({
      method: "post",
      url: "platform/admin/saveDepart",
      data,
    });
  },
  // 保存预览
  savePreview(data) {
    return axios({
      method: "post",
      url: "platform/admin/savePreview",
      data,
    });
  },
  // 获取擅长科室
  getDoctorBeGoodsAt(data) {
    return axios({
      method: "post",
      url: "platform/Admin/getDoctorBeGoodsAt",
      data,
    });
  },
  // 诊疗首页商品设置（回显）
  getGoodsSetting(data) {
    return axios({
      method: "post",
      url: "platform/admin/getGoodsSetting",
      data,
    });
  },
  // 保存诊疗首页商品设置
  saveGoodsSetting(data) {
    return axios({
      method: "post",
      url: "platform/admin/saveGoodsSetting",
      data,
    });
  },
  /* **** 诊疗banner设置 **** */
  //添加banner分类
  addHomeCategoryName(data) {
    return axios({
      method: "post",
      url: "platform/Admin/addHomeCategoryName",
      data,
    });
  },
  //编辑banner分类
  updateHomeCategoryName(data) {
    return axios({
      method: "post",
      url: "platform/Admin/updateHomeCategoryName",
      data,
    });
  },
  // 诊疗banner设置列表
  homeList(data) {
    return axios({
      method: "post",
      url: "platform/Admin/homeList",
      data,
    });
  },
  // 删除
  deleteHome(data) {
    return axios({
      method: "post",
      url: "platform/Admin/deleteHome",
      data,
    });
  },
  // 禁用或启用
  updateHomeStatus(data) {
    return axios({
      method: "post",
      url: "platform/Admin/updateHomeStatus",
      data,
    });
  },
  // 设置可见性
  setHome(data) {
    return axios({
      method: "post",
      url: "platform/Admin/setHome",
      data,
    });
  },
  // 添加屏样式
  addHome(data) {
    return axios({
      method: "post",
      url: "platform/Admin/addHome",
      data,
    });
  },
  // 上移/下移
  setHomeSort(data) {
    return axios({
      method: "post",
      url: "platform/Admin/setHomeSort",
      data,
    });
  },
  // 添加banner
  addHomeBanner(data) {
    return axios({
      method: "post",
      url: "platform/Admin/addHomeBanner",
      data,
    });
  },
  // 编辑banner
  editHomeBanner(data) {
    return axios({
      method: "post",
      url: "platform/Admin/editHomeBanner",
      data,
    });
  },
  // 删除banner
  deleteHomeBanner(data) {
    return axios({
      method: "post",
      url: "platform/Admin/deleteHomeBanner",
      data,
    });
  },
  // 左移/右移
  setHomeBannerSort(data) {
    return axios({
      method: "post",
      url: "platform/Admin/setHomeBannerSort",
      data,
    });
  },
  // 添加专栏
  columnAdd(data) {
    return axios({
      method: "post",
      url: "platform/Column/add",
      data,
    });
  },
  // 编辑专栏
  columnEdit(data) {
    return axios({
      method: "post",
      url: "platform/Column/edit",
      data,
    });
  },
  // 获取专栏列表
  columnGetList(data) {
    return axios({
      method: "post",
      url: "platform/Column/getList",
      data,
    });
  },
  // 发布专栏
  columnPublish(data) {
    return axios({
      method: "post",
      url: "platform/Column/publish",
      data,
    });
  },
  // 下架专栏
  columnOff(data) {
    return axios({
      method: "post",
      url: "platform/Column/off",
      data,
    });
  },
  // 删除专栏
  columnDelete(data) {
    return axios({
      method: "post",
      url: "platform/Column/delete",
      data,
    });
  },
  // 设置专栏排序
  columnSetSort(data) {
    return axios({
      method: "post",
      url: "platform/Column/setSort",
      data,
    });
  },
  // 获取脱敏字段列表
  getColumnConfig(data) {
    return axios({
      method: "post",
      url: "platform/admin/getColumnConfig",
      data,
    });
  },
};
